module.exports = __webpack_public_path__ + "img/tropical-pavlova.171642ac.jpg";